var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"_bg":"white","_p":"x-22px y-10px"}},[_c('div',{staticClass:"ability-detail-header",attrs:{"_m":"l-[-12px]"},on:{"click":_vm.routeBack}},[_c('i',{staticClass:"el-icon-arrow-left",staticStyle:{"margin-right":"5px"}}),_vm._v("返回 ")]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('div',[_vm._v("课堂常规")]),_c('div',[_vm._v("当前评级：A")])])])
}]

export { render, staticRenderFns }